import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import Swal from 'sweetalert2'
import { baseurl, baseurImage } from '../../Baseurl'
import axiosInstance from '../../api/axiosInstance'

const StaffPermissions = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [selectedAccount, setSelectedAccount] = useState(null)
  const [permissions, setPermissions] = useState({})
  const [expandedModules, setExpandedModules] = useState({})
  const [modulesList, setModulesList] = useState([])
  const [loading, setLoading] = useState(true)

  // Static modules list - COMMENTED OUT (now using dynamic data from API)
  // const modulesList = useMemo(() => (
  //   [
  //     {
  //       key: 'patients',
  //       label: 'Patients',
  //       submodules: [
  //         { key: 'Personal_Data', label: 'Personal_Data ' },
  //         { key: 'Appointment', label: 'Appointment' },
  //         { key: 'Vital_Signs', label: 'Vital_Signs' },
  //         { key: 'Forms', label: 'Forms' },
  //         { key: 'Labs', label: 'Labs' },
  //         { key: 'Medical_History', label: 'Medical_History' },
  //         { key: 'Dental', label: 'Dental' },
  //         { key: 'Services', label: 'Services' },
  //         { key: 'Biling', label: 'Biling' },
  //         { key: 'Insurance', label: 'Insurance' }
  //       ]
  //     },
  //     {
  //       key: 'appointments',
  //       label: 'Appointments',
  //       submodules: [
  //         { key: 'New Appointment', label: 'New Appointment' },
  //         { key: 'cancel_appointments', label: 'Cancel Appointments' },
  //       ]
  //     },
  //     {
  //       key: 'labs',
  //       label: 'Lab Requests',
  //       submodules: [
  //         { key: 'labs', label: 'Labs' },
  //         { key: 'lab_services', label: 'Lab Services' },
  //       ]
  //     },
  //     {
  //       key: 'billing',
  //       label: 'Billing',
  //       submodules: [
  //         { key: 'invoices', label: 'Invoices' },
  //         { key: 'payment_invoices', label: 'Payment Invoices' },
  //       ]
  //     },
  //     {
  //       key: 'pharmacy',
  //       label: 'Pharmacy',
  //       submodules: [
  //         { key: 'prescriptions', label: 'Prescriptions' },
  //         { key: 'inventory', label: 'Inventory' },
  //         { key: 'rx_standard_list', label: 'Rx Standard List' },
  //       ]
  //     },
  //     {
  //       key: 'medicals',
  //       label: 'Medicals',
  //       submodules: [
  //         { key: 'icd_10_list', label: 'ICD-10 List' },
  //         { key: 'dignosis_list', label: 'Diagnosis List' },
  //         { key: 'service_category', label: 'Service Category' },
  //         { key: 'allergy', label: 'Allergy' },
  //         { key: 'chronic_illness', label: 'Chronic Illness' },
  //         { key: 'chief_complaint', label: 'Chief Complaint' },
  //         { key: 'history_of_past_illness', label: 'History of Past Illness' },
  //         { key: 'history_of_present_illness', label: 'History of Present Illness' },
  //         { key: 'examination_general', label: 'Examination General' },
  //         { key: 'examination_local', label: 'Examination Local' },
  //         { key: 'examination_systemic', label: 'Examination Systemic' },
  //         { key: 'advises', label: 'Advises' },
  //         { key: 'extra_notes', label: 'Extra Notes' },
  //         { key: 'treatment_plan', label: 'Treatment Plan' },
  //         { key: 'family_history', label: 'Family History' },
  //         { key: 'psychosocial', label: 'Psychosoical' }
  //       ]
  //     },
  //     {
  //       key: 'insurance',
  //       label: 'Insurance',
  //       submodules: [
  //         { key: 'claims', label: 'Claims' },
  //         { key: 'companies', label: 'Companies' },
  //       ]
  //     },
  //     {
  //       key: 'services',
  //       label: 'Services',
  //       submodules: []
  //     },
  //     {
  //       key: 'reports',
  //       label: 'Reports',
  //       submodules: [
  //         { key: 'general_reports', label: 'General Reports' },
  //         { key: 'laboratory_reports', label: 'Laboratory Reports' },
  //         { key: 'medical_reports', label: 'Medical Reports' },
  //         { key: 'financial_reports', label: 'Financial Reports' },
  //         { key: 'daily_reports', label: 'Daily Reports' }
  //       ]
  //     },
  //     {
  //       key: 'settings',
  //       label: 'Settings',
  //       submodules: [
  //         { key: 'business_settings', label: 'Business settings' },
  //         { key: 'finance', label: 'Finance' },
  //         { key: 'notification_center', label: 'Notification Center' },
  //         { key: 'security', label: 'Security' },
  //         { key: 'medical_safety', label: 'Medical Safety' },
  //         { key: 'api_integration', label: 'API Integration' },
  //         { key: 'user', label: 'User' },
  //       ]
  //     }
  //   ]
  // ), [])

  // Standard modules that should be shown — DB may contain extra entries that must be excluded
  const ALLOWED_MODULES = {
    dashboard:    ['Dashboard_Analytics'],
    patients:     ['Personal_Data', 'Appointment', 'Vital_Signs', 'Forms', 'Labs', 'Medical_History', 'Dental', 'Services', 'Biling', 'Insurance'],
    appointments: ['Add_Appointment', 'cancel_appointments'],
    labs:         ['labs', 'lab_services'],
    billing:      ['invoices', 'payment_invoices'],
    pharmacy:     ['prescriptions', 'inventory', 'rx_standard_list'],
    medicals:     ['icd_10_list', 'dignosis_list', 'service_category', 'allergy', 'chronic_illness', 'chief_complaint', 'history_of_past_illness', 'history_of_present_illness', 'examination_general', 'examination_local', 'examination_systemic', 'advises', 'extra_notes', 'treatment_plan', 'family_history', 'psychosocial'],
    insurance:    ['claims', 'companies'],
    services:     [],
    reports:      ['general_reports', 'laboratory_reports', 'medical_reports', 'financial_reports', 'daily_reports'],
    settings:     ['business_settings', 'finance', 'notification_center', 'security', 'medical_safety', 'api_integration', 'user'],
  }

  const fetchModules = async () => {
    try {
      setLoading(true)
      const response = await axiosInstance.get(`getAllModulesWithSubModules`)

      if (response.data.success && response.data.data) {
        const dbModules = response.data.data

        // ALLOWED_MODULES controls which modules appear (blocks extra DB modules).
        // Within each allowed module, ALL DB submodules are shown, plus any
        // hardcoded submodules not yet in the DB (id: null).
        const transformedModules = Object.entries(ALLOWED_MODULES).map(([moduleName, hardcodedSubs]) => {
          const dbModule = dbModules.find(m => m.module_name === moduleName)
          const dbSubs   = dbModule?.sub_modules || []

          // All submodules from DB for this module
          const merged = dbSubs.map(s => ({
            key:   `${moduleName}_${s.sub_module_name}`,
            label: s.sub_module_name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
            id:    s.id
          }))

          // Append any hardcoded entries missing from DB (so they still appear)
          hardcodedSubs.forEach(subName => {
            if (!dbSubs.find(s => s.sub_module_name === subName)) {
              merged.push({
                key:   `${moduleName}_${subName}`,
                label: subName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
                id:    null
              })
            }
          })

          return {
            key:        moduleName,
            label:      moduleName.charAt(0).toUpperCase() + moduleName.slice(1),
            submodules: merged
          }
        })

        setModulesList(transformedModules)
      }
    } catch (error) {
      console.error('Error fetching modules:', error)
      Swal.fire('Error', 'Failed to load modules. Please try again.', 'error')
    } finally {
      setLoading(false)
    }
  }



  const fetchUserPermissions = async (userId) => {
    try {
      const response = await axiosInstance.get(`getUserPermissions/${userId}`);

      if (response.data.success && response.data.data) {
        // API now returns data as array of objects: 
        // { success: true, doctor_id: "76", data: [{id, doctor_id, sub_module_id, ...}, ...] }
        // Extract sub_module_id from each object in the array
        const userSubModuleIds = Array.isArray(response.data.data)
          ? response.data.data.map(item => item.sub_module_id)
          : [];


        const updatePermissions = {};

        modulesList.forEach(module => {
          module.submodules.forEach(submodule => {
            const hasPermission = userSubModuleIds.includes(submodule.id);
            updatePermissions[submodule.key] = hasPermission;

          });
        });

        setPermissions(updatePermissions);
      }

    }
    catch (error) {
      console.error('Error fetching user permissions:', error)
      Swal.fire('Error', 'Failed to load user permissions. Please try again.', 'error')
    }
  }


  useEffect(() => {
    fetchModules()
  }, [])

  useEffect(() => {
    if (location.state?.account) {
      setSelectedAccount(location.state.account);
      if (modulesList.length > 0) {
        initPermissions();
        fetchUserPermissions(location.state.account.id);
      }
    } else {
      navigate('/settings/security')
    }
  }, [location.state, navigate, modulesList])

  const initPermissions = () => {
    const next = {}
    modulesList.forEach(module => {
      next[module.key] = false
      // Initialize submodule permissions
      module.submodules.forEach(submodule => {
        next[submodule.key] = false
      })
    })
    setPermissions(next)
  }

  const toggleModuleExpansion = (moduleKey) => {
    setExpandedModules(prev => ({
      ...prev,
      [moduleKey]: !prev[moduleKey]
    }))
  }

  const togglePermission = (key, isModule = false, moduleKey = null) => {
    setPermissions(prev => {
      const newPermissions = { ...prev }

      if (isModule) {
        // Toggle module and all its submodules
        const module = modulesList.find(m => m.key === key)
        const newValue = !prev[key]
        newPermissions[key] = newValue

        // Toggle all submodules to match parent
        if (module && module.submodules) {
          module.submodules.forEach(submodule => {
            newPermissions[submodule.key] = newValue
          })
        }
      } else {
        // Toggle submodule only - parent remains independent
        newPermissions[key] = !prev[key]
      }

      return newPermissions
    })
  }

  const handleSavePermissions = async () => {
    try {
      const selectedSubModulesIds = [];

      modulesList.forEach(module => {
        module.submodules.forEach(submodule => {
          if (permissions[submodule.key] && submodule.id != null) {
            selectedSubModulesIds.push(submodule.id);
          }
        });
      });

      const payload = {
        doctor_id: selectedAccount.id,
        sub_module_ids: selectedSubModulesIds
      };

      const response = await axiosInstance.post(
        `createPermissionByUser`,
        payload,

      );
      if (response.data.success) {
        Swal.fire("Success", "Permissions updated successfully", "success");
        navigate("/Admin/security");
      }
      else {
        Swal.fire("Error", response.data.message || "Failed to update permissions", "error");
      }
    }
    catch (error) {
      console.error(error);
      Swal.fire("Error", error.reponse?.data.message || "Something went wrong", "error");
    }

  }

  const handleBack = () => {
    navigate('/Admin/setting')
  }

  if (!selectedAccount || loading) {
    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="text-center">
            <h4>Loading...</h4>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="border rounded p-3">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h4 className="mb-1">
                <span
                  style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                  onClick={() => navigate(-1)}
                  title="Back"
                >
                  &larr;
                </span>
                Staff Permissions</h4>
              <p className="text-muted mb-0">
                <strong>Staff:</strong> {selectedAccount.fullName} |
                <strong> Role:</strong> {selectedAccount.role || 'Staff'} |
                <strong> ID:</strong> {selectedAccount.civilId}
              </p>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th style={{ width: '400px' }}>MODULE</th>
                      <th style={{ width: '100px' }}>PERMISSION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modulesList
                      .filter(module => module.submodules.some(s => s.id != null))
                      .map(module => {
                        const availableSubs = module.submodules.filter(s => s.id != null)
                        return (
                          <React.Fragment key={module.key}>
                            {/* Main Module Row */}
                            <tr>
                              <td>
                                <div className="d-flex align-items-center">
                                  <button
                                    className="btn btn-sm btn-link p-0 me-2"
                                    onClick={() => toggleModuleExpansion(module.key)}
                                    style={{ border: 'none', background: 'none' }}
                                  >
                                    <i className={`ti ti-chevron-${expandedModules[module.key] ? 'down' : 'right'}`}></i>
                                  </button>
                                  <strong>{module.label}</strong>
                                </div>
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={!!permissions[module.key]}
                                  onChange={() => togglePermission(module.key, true)}
                                />
                              </td>
                            </tr>

                            {/* Submodule Rows — only those with a DB entry */}
                            {expandedModules[module.key] && availableSubs.map(submodule => (
                              <tr key={submodule.key} style={{ backgroundColor: '#f8f9fa' }}>
                                <td style={{ paddingLeft: '40px' }}>
                                  <span className="text-muted">{submodule.label}</span>
                                </td>
                                <td>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={!!permissions[submodule.key]}
                                    onChange={() => togglePermission(submodule.key, false, module.key)}
                                  />
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        )
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end gap-3 mt-4">
            <button className="btn btn-secondary" onClick={handleBack}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleSavePermissions}>
              <i className="ti ti-device-floppy me-2"></i>Update Permissions
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StaffPermissions
